import { useIntl } from "react-intl";
import React from "react";
import MacroscopiaContainer from "../macroscopia.container";

function MacroscopiaContainerIntl() {
    const intl = useIntl()
    return (
        <MacroscopiaContainer intl={intl}></MacroscopiaContainer>
    );
  }

  export default MacroscopiaContainerIntl


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/tabs/macroscopia.intl.js